module.exports = __webpack_public_path__ + "static/img/download_icon.0dbd078c.svg";